<ng-container *ngIf="payload as p">
	<div class="comparison-compared-chart-container f-1-0" style="order: 1;">
		<apx-chart
			#comparedChart
			class="comparison-compared-chart f-1-0 animated fadeIn"
			[ngClass]="p.comparedOptions?.chart?.type === 'pie' || p.comparedOptions?.chart?.type === 'donut' ? 'pie-chart animated fadeIn' : p.comparedOptions?.chart?.type === 'radialBar' ? 'trends-radial-pie-chart' : (p.chartClass || '')"
			*ngIf="p.comparedOptions?.series?.length && !loading"
			[series]="p.comparedOptions?.series"
			[chart]="p.comparedOptions?.chart"
			[plotOptions]="p.comparedOptions?.plotOptions"
			[colors]="p.comparedOptions?.colors"
			[legend]="p.comparedOptions?.legend"
			[labels]="p.comparedOptions?.labels"
			[xaxis]="p.comparedOptions?.xaxis"
			[yaxis]="p.comparedOptions?.yaxis"
			[dataLabels]="p.comparedOptions?.dataLabels"
			[stroke]="p.comparedOptions?.stroke"
			[fill]="p.comparedOptions?.fill"
			[tooltip]="p.comparedOptions?.tooltip"
			[grid]="p.comparedOptions?.grid"
			[markers]="p.comparedOptions?.markers"
			[responsive]="p.comparedOptions?.responsive"
			[states]="p.comparedOptions?.states"
			[options]="{display: false}">
		</apx-chart>

		<div class="comparison-compared-placeholder" *ngIf="loading || !p.comparedOptions?.series?.length">
			<loader *ngIf="loading" height="70" width="70"></loader>
			<ng-container *ngIf="!loading">
				<span *ngIf="p.comparedTitle" class="comparison-panel-title">{{p.comparedTitle}}</span>
				<div class="f-1-0 d-flex align-items-center fw-normal" style="margin-top: -5%;">No data for selected time period</div>
			</ng-container>
		</div>
	</div>

	<div class="comparison-delta-panel f-1-0" style="order: 2;" [ngClass]="{'horizontal-category': p.isHorizontalCategory}">
		<div class="comparison-panel-title">Change Summary</div>
		<span class="comparison-panel-vs text-muted">(vs {{p.currentTitle}})</span>

		<div class="comparison-delta-items" *ngIf="!loading && p.deltas?.length; else comparisonDeltaLoadingOrEmpty">
			<div class="comparison-delta-item" *ngFor="let delta of p.deltas; trackBy: trackDelta" [ngClass]="getDeltaClass(delta)">
				<i class="far" [ngClass]="getDeltaIcon(delta)"></i>
				<span class="comparison-delta-value">
					{{formatChange(delta)}}<span class="comparison-delta-diff">{{formatDiff(delta)}}</span>
				</span>
				<span class="comparison-delta-label" *ngIf="!p.isHorizontalCategory">{{delta.label}}</span>
			</div>
		</div>

		<ng-template #comparisonDeltaLoadingOrEmpty>
			<div class="comparison-delta-empty">
				<loader *ngIf="loading" height="42" width="42"></loader>
				<span *ngIf="!loading">N/A</span>
			</div>
		</ng-template>
	</div>
</ng-container>
